import axios from "axios";
import { Base_URL } from "../url";

export const fetchItemGroups = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemGroupMaster/GetAllItemGroups`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item groups!";
  }
};

export const downloadItemGroupsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroupMaster/DownloadItemGroupsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading item groups data!";
  }
};